import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { ConduitMark } from "./Logos";

const LINKS = [
  { label: "Reply desk", href: "#reply" },
  { label: "Markets", href: "#markets" },
  { label: "How it works", href: "#how" },
  { label: "Demo", href: "#demo" },
  { label: "Work", href: "#work" },
  { label: "Pricing", href: "#pricing" },
  { label: "About", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        backdropFilter: scrolled ? "saturate(140%) blur(10px)" : "none",
        background: scrolled ? "rgba(245,242,234,0.82)" : "transparent",
        borderBottom: scrolled ? "1px solid var(--line)" : "1px solid transparent",
        transition: "background 0.3s ease, border-color 0.3s ease",
      }}
    >
      <div className="container-x flex items-center justify-between" style={{ height: 68 }}>
        <a href="#top" className="flex items-center gap-2.5">
          <ConduitMark size={26} color="var(--ink)" />
          <span className="flex items-baseline gap-2">
            <span style={{ fontFamily: "'Newsreader', Georgia, serif", fontWeight: 600, fontSize: 24, letterSpacing: "-0.01em" }}>Conduit</span>
            <span className="hidden md:inline" style={{ fontSize: 12.5, color: "var(--ink-soft)" }}>
              Outbound for market entry · UK, EU, US
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              style={{ fontSize: 14, color: "var(--ink-soft)", transition: "color 0.2s ease" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--ink)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--ink-soft)")}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#apply" className="btn btn-primary" style={{ padding: "9px 16px" }}>
          Apply <ArrowRight size={15} />
        </a>
      </div>
    </header>
  );
}
